import { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { PersonOutline } from '@mui/icons-material';
import { useUserContext } from '../../context/user';
import { useAuthContext } from '../../context/auth';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { ConfirmDialog } from '../dialogKit';

const Delete = ({ user }) => {
  const axiosPrivate = useAxiosPrivate();
  const { dispatch } = useUserContext();
  const { auth } = useAuthContext();
  const [error, setError] = useState(null);
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  const handleDelete = async () => {
    if (!auth) {
      setError('You must be logged in');
      return;
    }

    setBusy(true);
    setError(null);
    try {
      const response = await axiosPrivate.delete(`/api/users/${user._id}`);
      dispatch({ type: 'DELETE_USER', payload: response.data });
      setShow(false);
    } catch (error) {
      setError(error.response?.data?.error || 'Delete failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Tooltip title="Delete user">
        <IconButton
          color="secondary"
          size="small"
          onClick={() => { setError(null); setShow(true); }}
        >
          <DeleteIcon />
        </IconButton>
      </Tooltip>

      <ConfirmDialog
        open={show}
        onClose={() => setShow(false)}
        onConfirm={handleDelete}
        busy={busy}
        error={error}
        title="Delete user?"
        message="The account is removed and this person can no longer log in."
        item={user.name}
        itemDetail={user.email}
        itemIcon={PersonOutline}
        confirmLabel="Delete user"
      />
    </>
  );
};

export default Delete;
